import React, {useMemo} from 'react';
import {type SxProps, useTheme} from '@mui/material';
import {Link} from './Link';

type Props = {
  title: string;
  path: string;
  selected: boolean;
};

export const MenuButton: React.FC<Props> = ({title, selected, path}) => {
  const {palette} = useTheme();
  const sx = useMemo((): SxProps => {
    const boxStyle: SxProps = {
      pt: 0.375,
      pb: 0.25,
      px: 1,
      borderRadius: 4,
      cursor: 'pointer',
    };

    if (selected) {
      boxStyle.borderColor = palette.primary.contrastText;
      boxStyle.borderStyle = 'solid';
      boxStyle.borderWidth = 'thin';
    }

    return boxStyle;
  }, [selected, palette]);

  return (
    <Link
      title={title}
      sx={sx}
      to={path}
      textTransform="capitalize"
      variant="h4"
      kind="primary"
      mode="light"
    />
  );
};
